import * as React from "react";
import Skeleton from "react-loading-skeleton";
import { Button, Col, Row } from "reactstrap";

export const ManagerCardLoader = (props) => {
  return (
    <div className="info-card white-background">
      <Row>
        <Col>
          <div className="manager-name">
            <Skeleton width={350} />
          </div>
          <div className="manager-data">
            <p>
              <Skeleton width={250} />
            </p>
            <p>
              <Skeleton width={250} />
            </p>
            <p>
              <Skeleton width={250} />
            </p>
          </div>
        </Col>
      </Row>
      <Row className="top-space">
        <Col md="6" />
        <Col md="6">
          <Button id="btn-loader">
            <Skeleton height={30} />
          </Button>
        </Col>
      </Row>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/share/components/ChartLoader/ManagerCardLoader.tsx